import { useGetReferBannerQuery } from "api";
import { Skeleton } from "@mui/material";
import styled from "@emotion/styled";

const ReferBanner = () => {
  const { data, loading } = useGetReferBannerQuery();
  return (
    <div>
      {data?.getReferBanner && !loading ? (
        <Image src={data?.getReferBanner} alt="Refer Banner" />
      ) : (
        <Skeleton
          variant="rectangular"
          sx={{ width: "100%", height: "200px" }}
        />
      )}
    </div>
  );
};

export default ReferBanner;

const Image = styled.img`
  object-fit: contain;
  object-position: center;
  width: 100%;
`;
